import TomSelect from 'tom-select/dist/js/tom-select.complete';
import { hasFlag } from 'country-flag-icons'
import { Ajax } from './ajax';
import { faqs } from './faqs';
export class Select {

    /*
	 * Init the handler
	 *
	 */
    constructor() {
		const self = this;

		if(document.querySelector('#faq-select-input')) {
			const faqSelect = new TomSelect('#faq-select-input', {
				plugins: ['dropdown_input']
			});
			faqSelect.on('change', this.handleFaqSelectChange.bind(this));
		}

		if(document.querySelectorAll('.country-selector')) {
			document.querySelectorAll('.country-selector').forEach(selector => {
				const countrySelect = new TomSelect(selector, {
					plugins: ['clear_button'],
					maxOptions: null,
					render:{
						option: function(data, escape) {
							return self.getFlagOption(data, escape);
						},
						item: function(data, escape) {
							return self.getFlagOption(data, escape);
						}
					}
				});
				if(selector.dataset.type === 'compliance') {
					 countrySelect.on('change', self.handleSelectChange.bind(self));
				}
				if(selector.dataset.type === 'pricing-band') {
					countrySelect.on('change', self.handlePriceBandCountryChange.bind(self, countrySelect));
				}
			});
		}

		if(document.querySelector('#compliance_country')) {
			const comlianceCountrySelect = new TomSelect('#compliance_country', {
				plugins: ['dropdown_input']
			});
			comlianceCountrySelect.on('change', this.handleComplianceCountrySelectChange.bind(self, comlianceCountrySelect));
		}
    }

	/*
	 * Gets the formatted option / selection which includes the country flag
	 *
	 * @param   {object} options details
	 * @param   {function}
	 * @return  {string}
	 */
	getFlagOption(data, escape) {
		let flag = '';
		if( hasFlag(data.flag) ) {
			let flag_url = 'https://purecatamphetamine.github.io/country-flag-icons/3x2/'+ data.flag +'.svg'
			flag = '<img class="flag-icon" alt="'+ escape(data.text) +'" src="'+ flag_url +'">'
		}
		return '<div>'+flag + escape(data.text) + '</div>';
	}

    /*
	 * Update price band from select change
	 *
	 * @param     {string} term_id
	 * @param     {element} select
	 * @return    {void}
	 */
    handlePriceBandCountryChange(select, term_id) {
        const ajax = new Ajax(),
			  form = select.input.dataset.form
        ajax.getPriceBand(term_id, form)
    }

    /*
	 * Update page elements from a fetch request
	 *
	 * @param     {string} term_id
	 * @return    {void}
	 */
    handleSelectChange(term_id) {
        this.updateUrl(term_id);
        location.reload();
    }

    /*
	 * Update the URL using currently selected country
	 *
	 * @param     {string} term_id
	 * @return    {void}
	 */
	updateUrl(term_id) {
		let url = new URL(window.location.href);
        let search_params = url.searchParams;

		// Remove pagination fron the URL
		if(url.href.includes('/page')){
			url.href = url.href.substr(0, url.href.indexOf('page'));
		}

        search_params.set('country', term_id);
        url.search = search_params.toString();

        // Replace the current URL
		window.history.replaceState(
			null,
			document.title,
			decodeURI(url.toString())
		);
    }

	/*
	 * Update displayed FAQ section
	 *
	 * @param     {string} faq_id
	 * @return    {void}
	 */
    handleFaqSelectChange(faq_id) {
		const Faq = new faqs()
		Faq.updateFaqSection(faq_id)
    }

	/*
	 * Update displayed Compliance Country results
	 *
	 * @param     {string} country_id
	 * @return    {void}
	 */
	handleComplianceCountrySelectChange(select, country_id) {
		let url = select.input.dataset.url;
		if(country_id && url) {
			window.location.replace(url + '?country=' + country_id);
		}
	}
}
